import { GlanceDraftDetailsProps, PublishButtonAtributes } from './types';
import { GlanceType, Role } from 'glance-datatypes';

/**
 * This function will return value of disable and the
 * tooltipText for publsh button.
 */
export const isArticle = draft => {
  if (draft.peek == null) {
    return false;
  }
  return !draft.peek.video && !draft.peek.nativeVideoUrl && !draft.peek.webPeekUrl && !draft.peek.liveVideoPeek
};

export const getPublishButtonAtributes = ({
  editable,
  glanceDraftData: draft,
  studioAppConfig,
  pristine,
}): PublishButtonAtributes => {
  const userRole = studioAppConfig.currentToken.role;
  const userLifeTimeFilter = draft.userLifeTimeFilter || {
    startDay: null,
    endDay: null,
  };

  const startDay = userLifeTimeFilter.startDay;
  // if editable is false, publish button has to disabled
  if (!editable) {
    return { disable: true, tooltip: 'This Glance is not editable' }; // its removed.
  }
  // if there is no draft image, the publish button has to disabled
  if (!draft.image) {
    return { disable: true, tooltip: 'Missing Image' };
  } else if (!draft.image.attribution || !draft.image.attribution.source) {
    return { disable: true, tooltip: 'Missing Image Attribution' };
  }

  // if campaign is paused, publish button has to disabled
  if (draft.paused) {
    return { disable: true, tooltip: 'Draft Paused' };
  }

  // Disable publish if network type is missing
  if (!(draft.userNetworkTypes && draft.userNetworkTypes.length)) {
    return { disable: true, tooltip: 'Network type Missing' };
  }

  //Disable publish if ecpm is less than 1
  if ((draft.campaignMeta && draft.campaignMeta.eCpm && draft.campaignMeta.eCpm < 0.01)) {
    return { disable: true, tooltip: 'ECPM cannot be less than 0.01' };
  }

  //Disable publish if offlineShoppingZipUrl is not a .zip url
  if (draft.shoppableData && draft.shoppableData.offlineShoppingZipUrl) {
    let url = draft.shoppableData.offlineShoppingZipUrl.split("?")[0];
    if (!url.endsWith(".zip")) {
      return { disable: true, tooltip: "offlineShoppingZipUrl should end with .zip" };
    }
  }

  // Disable publish if offlinePeekUrl is not a .zip url
  if (draft.peek && draft.peek.offlinePeekUrl) {
    let url = draft.peek.offlinePeekUrl.split("?")[0];
    if (!url.endsWith(".zip")) {
      return { disable: true, tooltip: "offlinePeekUrl should end with .zip" };
    }
  }

  if (
    !(draft.renderSessionProperties && draft.renderSessionProperties.length)
  ) {
    return { disable: true, tooltip: 'Missing Session Mode' };
  }

  if (!pristine) {
    return { disable: true };
  }

  if (draft.peek) {
    if (!draft.peek.sourceName) {
      return { disable: true, tooltip: 'Missing Peek SourceName' };
    }
    if (isArticle(draft) && !(draft.peek.cta && draft.peek.cta.text)) {
      return { disable: true, tooltip: 'Article must have CTA Text' };
    }
  }

  switch (draft.type) {
    case GlanceType.STORY:
      if (!draft.categoryIds || draft.categoryIds.length == 0) {
        return { disable: true, tooltip: 'Missing categories' };
      }
      break;
    case GlanceType.SPONSORED:
      // Publisher data is a mandatory field for SPONSORED GlanceType.
      if (!draft.publisherData) {
        return {
          disable: true,
          tooltip: 'Publisher Data is mandatory for Sponsored Glance',
        };
      }
      break;
    default:
      break;
  }

  switch (userRole) {
    case Role.MODERATOR:
      break;
    case Role.ADMIN:
      break;
    default:
      return { disable: true, tooltip: 'Not Allowed' };
  }

  if (
    draft.userLifeTimeFilter &&
    startDay !== null &&
    startDay !== 8 &&
    draft.userLifeTimeFilter.endDay === null
  ) {
    return { disable: true, tooltip: 'End Day Missing' };
  }
  return { disable: false };
};



// WEBPACK FOOTER //
// ./src/pages/drafts/draftsHelper.ts